import type {ReactElement} from 'react';
import {getSectionColumnsPresets} from '@EmailMakerReact/lib/email-maker-table-library';
import type {SectionColumnsPreset} from '@EmailMakerReact/lib/email-maker-table-library';
import {RightPanelOverlayHeader} from '../../components/right-panel-overlay-header/right-panel-overlay-header';
import type {ColumnsAllViewProps} from './columns-all-view.types';
import styles from './columns-all-view.module.scss';

export function ColumnsAllView({onBack, onPresetSelect, selectedPresetId}: ColumnsAllViewProps): ReactElement {
  const allPresets = getSectionColumnsPresets();
  return (
    <div className={styles.view}>
      <RightPanelOverlayHeader title={window.i18next.t('pmwjs_columns')} backAriaLabel={window.i18next.t('pmwjs_back')} onBack={onBack} />
      <div className={styles.body}>
        <div className={styles.presetGrid}>{allPresets.map((preset) => renderPresetTile(preset, selectedPresetId, onPresetSelect))}</div>
      </div>
    </div>
  );
}

function renderPresetTile(preset: SectionColumnsPreset, selectedPresetId: number, onPresetSelect: (presetId: number) => void): ReactElement {
  const isSelected = preset.id === selectedPresetId;
  return (
    <button
      aria-pressed={isSelected}
      className={`preset-wrapper js-comp-preset ${styles.presetTile}`}
      data-preset-id={preset.id}
      key={preset.id}
      onClick={(): void => {
        onPresetSelect(preset.id);
      }}
      type="button"
    >
      {preset.compValues.map((widthPct, idx) => (
        <div className={`preset-comp ${styles.presetColumn}`} key={idx} style={{width: `${widthPct}%`}} />
      ))}
    </button>
  );
}
